import React, { ReactNode, createContext, useContext } from 'react';

interface PlaygroundParentContextType {
  isSimplified: boolean;
}

const PlaygroundParentContext = createContext<
  PlaygroundParentContextType | undefined
>(undefined);

export const usePlaygroundParentContext = (): PlaygroundParentContextType => {
  const context = useContext(PlaygroundParentContext);
  if (!context) {
    throw new Error(
      'usePlaygroundParentContext must be used within a PlaygroundParentContext'
    );
  }
  return context;
};

interface PlaygroundParentContextProviderProps {
  children: ReactNode;
  isSimplified?: boolean;
}

export const PlaygroundParentContextProvider: React.FC<
  PlaygroundParentContextProviderProps
> = ({ children, isSimplified = false }) => {
  return (
    <PlaygroundParentContext.Provider value={{ isSimplified }}>
      {children}
    </PlaygroundParentContext.Provider>
  );
};
